import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Event"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M21 4.5C21 3.67157 20.3284 3 19.5 3H16.5V1.5H15V3H9V1.5H7.5V3H4.5C3.67157 3 3 3.67157 3 4.5V19.5C3 20.3284 3.67157 21 4.5 21H7.5V19.5H4.5V4.5H7.5V6H9V4.5H15V6H16.5V4.5H19.5V9H21V4.5ZM15.75 11.25L17.6625 14.955L21.75 15.5475L18.75 18.4275L19.4925 22.5L15.8325 20.58L12 22.5L12.75 18.4275L9.75 15.5475L13.95 14.955L15.75 11.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Event.vue"]]);
